import { configureStore } from '@reduxjs/toolkit';
import appReducer from './App/App.slice';
import userReducer from './User/UserSlice';
import candidateReducer from './Candidate/Candidate.slice';
import eventReducer from './Event/Event.slice';
import eventStatusReducer from './Event/Status/EventStatus.slice';
import personRecordReducer from './Candidate/Record/Record.slice';
import jobReducer from './Job/Job.slice';
import snowReducer from './SnowFall/SnowFall.slice';
import sourceReducer from './Source/Source.slice';
import employeeReducer from './Employee/Employee.slice';
import regionReducer from './Region/Region.slice';
import departmentReducer from './Department/Department.slice';
import attachmentReducer from './Attachment/Attachment.slice';
import personLinkReducer from './Candidate/Link/PersonLink.slice';
import personExperienceReducer from './Candidate/Experience/PersonExperience.slice';
import personHistoryReducer from './Candidate/Record/History/History.slice';
import internshipReducer from './Internship/Internship.slice';
import notificationReducer from './Notification/NotificationSlice';
import reportReducer from './Report/Report.slice';
import { toastReducer } from '../hooks/useToast';
import centrifugoReducer from './Centrifugo/CentrifugoSlice';
import regionControlReducer from './ControlPanel/RegionControl/RegionControl.slice';
import hrControlReducer from './ControlPanel/HRControl/HRControl.slice';
import vacancyControlReducer from './ControlPanel/VacancyControl/VacancyControl.slice';
import sourceControlReducer from './ControlPanel/SourceControl/SourceControl.slice';
import statusControlReducer from './ControlPanel/StatusControl/StatusControl.slice';
import tagControlReducer from './ControlPanel/TagControl/TagControl.slice';
import internshipStatusControlReducer from './ControlPanel/InternshipStatusControl/InternshipStatusControl.slice'
import eventsReducer from './ControlPanel/Events/Events.slice';
import controlPanelListReducer from './ControlPanel/ControlPanelList/ControlPanelList.slice';
import hrVacanciesReducer from './Dashboard/HRVacancies/HRVacancies.slice';
import tagReducer from './Tag/Tag.slice';
import hrWidgetReducer from './Dashboard/HRWidget/HRWidget.slice';
import assistantReducer from './Assistant/Assistant.slice';
import calendarReducer from './Calendar/Calendar.slice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    candidate: candidateReducer,
    event: eventReducer,
    eventStatus: eventStatusReducer,
    personLink: personLinkReducer,
    personExperience: personExperienceReducer,
    personRecord: personRecordReducer,
    personHistory: personHistoryReducer,
    internship: internshipReducer,
    job: jobReducer,
    source: sourceReducer,
    snow: snowReducer,
    region: regionReducer,
    department: departmentReducer,
    employee: employeeReducer,
    attachments: attachmentReducer,
    notifications: notificationReducer,
    centrifugo: centrifugoReducer,
    toasts: toastReducer,
    regionControl: regionControlReducer,
    hrControl: hrControlReducer,
    vacancyControl: vacancyControlReducer,
    sourceControl: sourceControlReducer,
    statusControl: statusControlReducer,
    tagControl: tagControlReducer,
    internshipStatusControl: internshipStatusControlReducer,
    report: reportReducer,
    events: eventsReducer,
    controlPanelList: controlPanelListReducer,
    hrVacancies: hrVacanciesReducer,
    tag: tagReducer,
    hrWidget: hrWidgetReducer,
    assistant: assistantReducer,
    calendar: calendarReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
